import { createBrowserRouter } from "react-router-dom";
import Error from "../components/Error/Error";
import Main from "../layout/Main";
import Home from "../pages/Home";
import Packages from "../pages/Packages";
import Instructions from "../pages/Instructions";
import ISPs from "../pages/ISPs";
import Channels from "../pages/Channels";
import ChannelsTest from "../pages/ChannelsTest";
import SignUp from "../pages/SignUp";

const routes = createBrowserRouter([
  {
    path: "/",
    element: <Main />,
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "/plus",
        element: <Packages />,
      },
      {
        path: "/plus/instructions",
        element: <Instructions />,
      },
      {
        path: "/plus/channels",
        element: <Channels />,
      },
      {
        path: "/plus/isps-mdus",
        element: <ISPs />,
      },
      {
        path: "/plus/channelstest",
        element: <ChannelsTest />,
      },
      {
        path: "/plus/signup",
        element: <SignUp />,
      },
    ],
    errorElement: <Error />,
  },
]);

export default routes;
